<template>
  <div class="shareModel">
    <div class="shareBox">
      <div class="shareBtn">
        <a @click="share_twitter">
          <img src="@/assets/imgs/share/twitter_new.png" width="100%" alt="" />
          <span class="shareTxt">X</span>
        </a>
        <a @click="shareFacebook">
          <img src="@/assets/imgs/share/facebook.png" width="100%" alt="" />
          <span class="shareTxt">Facebook</span>
        </a>
        <!-- <a @click="shareSina">
                        <img src="@/assets/imgs/share/sina.png" width="100%" alt="" />
                        <span class="shareTxt">Weibo</span>
                    </a> -->
        <a @click="shareWhats">
          <img src="@/assets/imgs/share/whats.png" width="100%" alt="" />
          <span class="shareTxt">Whats</span>
        </a>
        <a @click="showWx">
          <img src="@/assets/imgs/share/wexin.png" width="100%" alt="" />
          <span class="shareTxt">Wechat</span>
        </a>
      </div>
      <div class="cancleBtn" @click="closeShareModel">
        Cancel
      </div>
    </div>
  </div>
</template>
<script>
import { setNewShare } from "@/network/share.js";
export default {
  name: "Share",
  props: ["detailData", "postImg"],
  data() {
    return {
      num: 0,
      categoryArr: [],
      status: 0,
      isOk: true,
      postId: "",
      share_title: "",
      share_url: "",
      shareBoxLeft: 0,
      showPoster: true,
      clientWidth: 0,
      tempImgUrl: "",
    };
  },
  mounted() {
    this.clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    // this.handleArr();
    this.num = this.detailData.numOfLikes;
    this.status = localStorage.getItem(this.detailData.postId);

    // 分享参数
    this.share_title = this.detailData.postTitle;
    this.share_url = window.location.href;
    // alert(this.share_url)
    this.setPosition();
    this.handelImg();
  },
  methods: {
    handelImg() {
      var pointlength = this.detailData.imageUrl.lastIndexOf(".");
      var alllength = this.detailData.imageUrl.length;
      var str1 = this.detailData.imageUrl.substr(0, pointlength);
      var str2 = this.detailData.imageUrl.substr(pointlength, alllength);
      var newStr;
      newStr = str1 + "_related" + str2;
      this.tempImgUrl = newStr;
    },

    closeShareModel() {
      this.$store.state.showShareModel = false;
      var s_body = document.querySelector("body");
      s_body.style.overflowY = "auto";
    },
    setPosition() {
      // console.log( document.body.clientWidth)
      this.shareBoxLeft = (document.body.clientWidth - 600) / 2;
      // alert(this.shareBoxLeft)
    },
    share_twitter() {
      // return
      let postId = this.detailData.postId;
      setNewShare({
        id: postId,
        website: "twitter",
      }).then((res2) => {
        let twitterUrl = res2.data;
        if (this.clientWidth > 750) {
          window.open(
            twitterUrl,
            "",
            "width=600, height=500, left=" + this.shareBoxLeft + ", top=150"
          );
        } else {
          location.href = twitterUrl;
        }
      });
    },

    shareFacebook() {
      let postId = this.detailData.postId;
      setNewShare({
        id: postId,
        website: "facebook",
      }).then((res) => {
        let _uri = res.data;
        if (this.clientWidth > 750) {
          window.open(
            _uri,
            "",
            "width=600, height=500, left=" + this.shareBoxLeft + ", top=150"
          );
        } else {
          location.href = _uri;
        }
      });

      return;
    },
    showWx() {
      this.$emit("showWxFn");
    },
    shareSina() {
      let sinaUrl =
        "http://service.weibo.com/share/share.php?appkey=&title=" +
        encodeURIComponent(this.share_title) +
        "&url=" +
        this.share_url;
      window.open(
        sinaUrl,
        "",
        "width=600,height=500,scrollbars=1,left=" +
          this.shareBoxLeft +
          ", top=150"
      );
    },
    shareWhats() {
      const imgUrl = this.$store.state.baseUrl + this.tempImgUrl;
      const title = this.share_title;
      const url = this.share_url;
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
        title + " " + url
      )}&image=${encodeURIComponent(imgUrl)}`;
      // 打开新窗口或标签页以分享到WhatsApp
      window.open(whatsappUrl, "_blank");
    },
  },
};
</script>
<style lang="less">
.shareModel {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1000;
}

@media screen and (max-width: 768px) {
  .shareModel {
    .shareBox {
      height: 200px;
      width: calc(100% - 20px);
      margin: 0 10px;
      position: absolute;
      bottom: 10px;
      .shareBtn {
        height: 117px;
        background: #ffffff;
        display: flex;
        justify-content: space-around;
        a {
          width: 45px;
          height: 117px;
          flex: 1;
          margin: 0 25px;
          text-align: center;
          cursor: pointer;
          img {
            margin-top: 10px;
          }
          .shareTxt {
            font-size: 14px;
            font-family: Open Sans;
            font-weight: 400;
            color: #666666;
            line-height: 10px;
            position: relative;
            top: -22px;
          }
        }
      }
      .cancleBtn {
        height: 45px;
        background: #ffffff;
        margin-top: 10px;
        color: #47abe5;
        font-size: 14px;
        font-family: Open Sans;
        line-height: 45px;
        text-align: center;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .shareModel {
    .shareBox {
      height: 200px;
      width: calc(100% - 20px);
      margin: 0 10px;
      position: absolute;
      bottom: 10px;
      .shareBtn {
        width: 100%;
        height: 117px;
        background: #ffffff;
        display: flex;
        justify-content: space-around;
        a {
          width: 45px;
          height: 117px;
          flex: 1;
          margin: 0 25px;
          text-align: center;
          img {
            cursor: pointer;
            margin-top: 10px;
          }
          .shareTxt {
            font-size: 14px;
            font-family: Open Sans;
            font-weight: 400;
            color: #666666;
            line-height: 10px;
            position: relative;
            cursor: pointer;
            top: -22px;
          }
        }
      }
      .cancleBtn {
        height: 45px;
        background: #ffffff;
        margin-top: 10px;
        color: #47abe5;
        font-size: 14px;
        font-family: Open Sans;
        line-height: 45px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .shareModel {
    .shareBox {
      height: 300px;
      width: calc(100% - 0px);
      padding: 0 5%;
      margin: 0 10px;
      position: absolute;
      //   background: #666666;
      bottom: 10px;
      .shareBtn {
        width: 100%;
        height: 167px;
        background: #ffffff;
        a {
          display: block;
          width: 25%;
          height: 167px;
          text-align: center;
          //   background: orange;
          float: left;
          img {
            width: 45px;
            width: 45px;
            cursor: pointer;
            margin-top: 0px;
          }
          .shareTxt {
            display: block;
            font-size: 18px;
            font-family: Open Sans;
            font-weight: 400;
            color: #666666;
            cursor: pointer;
            position: relative;
          }
        }
      }
      .cancleBtn {
        height: 65px;
        background: #ffffff;
        margin-top: 30px;
        color: #47abe5;
        font-size: 18px;
        font-family: Open Sans;
        line-height: 65px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>
